import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LorenLayerSelectionDialogComponent } from './components/loren-layer-selection-dialog/loren-layer-selection-dialog.component';



@NgModule({
    declarations: [LorenLayerSelectionDialogComponent],
    exports: [
        LorenLayerSelectionDialogComponent
    ],
    imports: [
        CommonModule
    ]
})
export class LorenLayersSelectionDialogModule { }
